module.exports = __webpack_public_path__ + "static/img/li3_3.e305977e.png";